import { useTheme } from '@mui/material';
import { CriticalIcon } from 'src/assets/icons/CriticalIcon';
import { LightTooltip } from 'src/components';
import { SuccessIcon } from 'src/features/theme/overrides/CustomIcons';

type HandlePriorityProps = {
  isActive?: boolean;
};

export const HandlePriority = ({ isActive }: HandlePriorityProps) => {
  const theme = useTheme();

  return isActive ? (
    <LightTooltip title="Active alarms" enterTouchDelay={0} placement="left-end" arrow>
      <div data-sm="critical-icon">
        <CriticalIcon fill={theme.palette.error.main} />
      </div>
    </LightTooltip>
  ) : (
    <LightTooltip title="No active alarms" enterTouchDelay={0} placement="left-end" arrow>
      <div data-sm="success-icon">
        <SuccessIcon htmlColor={theme.palette.success.main} />
      </div>
    </LightTooltip>
  );
};
